import NotFound from "@/components/Common/NotFound";
import {i18n} from "@/i18n";
import PendingAmbassadors from "@/pages/PendingAmbassadors";
import {InfluencerSidebarStoreProvider} from "@/store/influencerSidebarContext";
import {selectedCompanyIdAtom} from "@/store/jotaiAtoms";
import {fetchCompany} from "@/utils/loaderUtils";
import {createFileRoute, notFound} from "@tanstack/react-router";
import {getDefaultStore} from "jotai";

export const Route = createFileRoute(
  "/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/pending-ambassadors",
)({
  component: RouteComponent,
  notFoundComponent: () => (
    <NotFound message={i18n.t("groups:company_not_found")} page={i18n.t("common:dashboard")} redirect="/" />
  ),
  params: {
    parse: raw => ({
      agencyId: +raw.agencyId,
      companyId: +raw.companyId,
    }),
    stringify: params => ({
      agencyId: params.agencyId?.toString(),
      companyId: params.companyId?.toString(),
    }),
  },
  loader: async ({params}) => {
    const company = await fetchCompany(params.companyId).catch(() => null);

    if (!company) {
      throw notFound();
    }

    getDefaultStore().set(selectedCompanyIdAtom, params.companyId);
  },
});

function RouteComponent() {
  const {companyId} = Route.useParams();

  return (
    <InfluencerSidebarStoreProvider>
      <PendingAmbassadors companyId={companyId} />
    </InfluencerSidebarStoreProvider>
  );
}
